import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { PageComponentProductCarouselComponent } from '../../../page/component/product-carousel/product-carousel.component';
import { PRODUCT_CAROSUEL_CONFIG } from '../../../page/component/product-carousel/product-carousel.config';
import { IPageComponentProductCarouselData } from '../../../page/component/product-carousel/product-carousel.interface';

export namespace NCmsProductViewCarousel {
    export const BLOCK_ID = 'product-view-cms-carousel';

    export interface IBlockData extends Catalog.IBlockData<IBlockContent> {}

    export interface IBlockContent extends IPageComponentProductCarouselData {
        hasOverride: boolean;
    }
}

@Component({
    selector: 'product-view-cms-carousel',
    templateUrl: './product-view-cms-carousel.html',
    standalone: true,
    imports: [PageComponentProductCarouselComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductViewCmsCarouselComponent>({
    id: NCmsProductViewCarousel.BLOCK_ID,
    name: 'Carousel settings',
    onDemandOnly: true,
    block: {
        url: NCmsProductViewCarousel.BLOCK_ID
    },
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IToggleField>{
            key: 'hasOverride',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Use layout defaults',
            invert: true
        },
        ...[
            {
                type: NICmsContentField.EFieldType.label,
                key: 'section-fields',
                title: 'General'
            },
            ...PRODUCT_CAROSUEL_CONFIG.fields
        ].map(field => ({
            ...field,
            canShow: (data: NCmsProductViewCarousel.IBlockContent, outletOptions: NICmsContentComponent.IOutletOptions): boolean =>
                !!(data?.hasOverride && (!field.canShow || field.canShow(data, outletOptions)))
        }))
    ]
})
export class ProductViewCmsCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsProductViewCarousel.IBlockContent;

    @Input()
    variant?: string;

    @Input()
    defaultComponents?: NICmsContentComponent.IData[];

    override detectChanges(): void {
        if (this.content && !this.content.id) {
            this.content.id = PRODUCT_CAROSUEL_CONFIG.id;
        }
        super.detectChanges();
    }
}
